"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userServiceVisitInfoSchema = void 0;
const zod_1 = require("zod");
exports.userServiceVisitInfoSchema = zod_1.z.object({
  /** Просмотрено текущим пользователем */
  is_viewed: zod_1.z.boolean().optional(),
  /** Дата последнего просмотра */
  last_viewed_at: zod_1.z.string().datetime().or(zod_1.z.date()).optional(),
  /** Добавлено в избранное */
  is_favorite: zod_1.z.boolean().optional(),
  /** Дата добавления в избранное */
  favorited_at: zod_1.z.string().datetime().or(zod_1.z.date()).optional(),
  /** Пользователь подписан */
  is_following: zod_1.z.boolean().optional(),
  /** Дата подписки */
  followed_at: zod_1.z.string().datetime().or(zod_1.z.date()).optional()
});
